<template>
	<BaseModal :title="t('title')" v-model="show" noPadding>
		<div class="px-5">
			<div
				class="via-fill-tertiary to-fill-tertiary sticky -top-16 z-1 -mt-4 bg-linear-to-t from-transparent py-4"
			>
				<SearchInput :placeholder="t('search')" v-model="search" />
			</div>
			<div class="flex flex-col gap-4 pb-4">
				<FilterItem
					v-for="item in filteredItems"
					:src="icon(item.uuid)"
					:title="item.name"
					:price="item.floorCoins"
					:listings="item.listings"
					:preloader="item.preloader || undefined"
					:selected="selected.includes(item.name)"
					@click="toggleSelection(item.name)"
					v-hover="{ active: 'scale-95', impact: 'soft' }"
				/>
			</div>
		</div>
		<BottomActionsModal class="flex gap-3 pt-4">
			<BaseButton size="lg" color="secondary" class="flex-1" @click="clear()">
				{{ t('clear') }}
			</BaseButton>
			<BaseButton size="lg" color="primary" class="flex-1" @click="confirm()">
				{{ t('confirm') }}
			</BaseButton>
		</BottomActionsModal>
	</BaseModal>
</template>
<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import BaseModal from './BaseModal.vue'
import BaseButton from '../BaseButton.vue'
import SearchInput from '../SearchInput.vue'
import FilterItem from '../FilterItem.vue'
import { icon } from '@/utils/urls'
import { useI18n } from 'vue-i18n'
import BottomActionsModal from '../BottomActionsModal.vue'

const { t } = useI18n({
	messages: {
		en: {
			title: 'collection',
			search: 'Search by collection...',
			clear: 'clear',
			confirm: 'confirm'
		},
		ru: {
			title: 'коллекция',
			search: 'Поиск по коллекции...',
			clear: 'сбросить',
			confirm: 'подтвердить'
		}
	}
})

const props = defineProps<{
	items: {
		uuid: string
		name: string
		floorCoins: number
		listings: number
		preloader?: string | null
	}[]
}>()

const emit = defineEmits<{
	(e: 'toggleSelection', name: string): void
}>()

const show = defineModel<boolean>('show')
const selected = defineModel<string[]>('selected', { default: [] })
const search = ref('')

const filteredItems = computed(() => {
	if (!search.value) {
		return props.items
	}

	const lowered = search.value.toLowerCase()

	return props.items.filter((item) => item.name.toLowerCase().includes(lowered))
})

const toggleSelection = (name: string) => emit('toggleSelection', name)

const clear = () => {
	selected.value = []
}
const confirm = () => {
	show.value = false
}
</script>
